import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzButtonModule } from 'ng-zorro-antd/button';


import {
  PhxDividerModule,
  PhxDropdownModule,
  PhxMenuButtonModule,
  PhxMenuModule,
  PhxIconModule,
  PhxTooltipModule,
  PhxButtonModule,
  PhxBadgeModule,
  PhxUnderlineModule,
} from 'phx-core';

import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { CommonPipesModule } from '../pipes/module';
import { UpsellModule } from '../misc/upsell/module';
import { DismissalNoteModule } from '@misc/dismissal-note/module';

import { LogoutComponent } from './logout.component';
import { RestrictedComponent } from './restricted.component';
import { ConfirmPromptModalComponent } from './confirm-prompt.component';
import { CollapsibleListComponent } from './collapsible-list.component';
import { CrossLinkComponent } from './cross-link.component';
import { DutyStatusIconComponent } from './duty-status-icon.component';
import { LongTextComponent } from './long-text.component';
import { TipComponent } from './tip.compnent';
import { SearchInputComponent } from './search-input.component';
import { NotesModalComponent } from './notes-modal.component';
import { ProgressLoaderComponent } from './progress-loader.component';
import { ImagePanZoomComponent } from './image-pan-zoom.component';
import { ImagePanZoomViewerComponent } from './image-pan-zoom-viewer.component';
import { PortalComponent } from './portal.component';
import { SelectionPillsComponent } from './selection-pills.component';
import { NotesPopupComponent } from './notes-popup.component';
import { LogoComponent } from './logo.component';
import { DateTimePickerComponent } from './date-time-picker.component';
import { KebabMenuComponent } from './kebab-menu.component';
import { DetailCardComponent } from './detail-card.component';
import { GroupedTabsetComponent } from './grouped-tabset.component';
import { CollapsibleBreadcrumbComponent } from './collapsible-breadcrumb.component';
import { CardRowComponent } from './card-row.component';
import { AdaUnavailableModalComponent } from './ada-unavailable-modal.component';
import { EntityTableCellComponent } from './entity-table-cell/entity-table-cell.component';

import { AutoDropdownDirective } from './auto-dropdown.directive';
import { TemplateNameDirective } from './template-name.directive';
import { EllipsizeDirective } from './ellipsize.directive';
import { HeightOverflowDirective } from './height-overflow.directive';
import { NaturalNumbersOnlyInputDirective } from './natural-numbers-only-input.directive';
import { IfCssSupportDirective } from './if-css-support.directive';
import { ScrollPercentDirective } from './scroll-percent.directive';
import { StickyAdjacentChildrenDirective } from './sticky-adjacent-children.directive';
import { FixChildrenWidthsDirective } from './fix-children-widths.directive';
import { TooltipOnTruncateDirective } from './tooltip-on-truncate.directive';
import { PhxKebabMenuComponent } from './phx-kebab-menu.component';
import { InfoPopupModule } from './Info-popup.module';
import { TooltipDirectiveModule } from './tooltip.directive.module';
import { ChartTooltipComponent } from './chart-tooltip.component';
import { SpendControlTooltipV4Component } from '@app/admin/fleet-card/shared/spend-controls/spend-control-tooltip-v4.component';
import { TableEmptyStateComponent } from './table-empty-state/table-empty-state.component';

const COMPONENTS = [
  LogoutComponent,
  RestrictedComponent,
  ConfirmPromptModalComponent,
  AutoDropdownDirective,
  CollapsibleListComponent,
  CrossLinkComponent,
  DutyStatusIconComponent,
  LongTextComponent,
  TemplateNameDirective,
  TipComponent,
  SearchInputComponent,
  EllipsizeDirective,
  TooltipOnTruncateDirective,
  HeightOverflowDirective,
  NaturalNumbersOnlyInputDirective,
  ScrollPercentDirective,
  NotesModalComponent,
  IfCssSupportDirective,
  ProgressLoaderComponent,
  ImagePanZoomComponent,
  ImagePanZoomViewerComponent,
  StickyAdjacentChildrenDirective,
  FixChildrenWidthsDirective,
  PortalComponent,
  SelectionPillsComponent,
  NotesPopupComponent,
  LogoComponent,
  DateTimePickerComponent,
  GroupedTabsetComponent,
  CollapsibleBreadcrumbComponent,
  KebabMenuComponent,
  DetailCardComponent,
  CardRowComponent,
  AdaUnavailableModalComponent,
  PhxKebabMenuComponent,
  ChartTooltipComponent,
  SpendControlTooltipV4Component,
  EntityTableCellComponent,
  TableEmptyStateComponent,
];

@NgModule({
  imports: [
    FormsModule,
    NzCardModule,
    NgCommonModule,
    RouterModule,
    CommonPipesModule,
    UpsellModule,
    NzDropDownModule,
    NzCheckboxModule,
    NzDatePickerModule,
    DragDropModule,
    NzInputModule,
    NzIconModule,
    NzDividerModule,
    NzTabsModule,
    NzBreadCrumbModule,
    NzTagModule,
    NzButtonModule,
    PhxButtonModule,
    PhxBadgeModule,
    PhxDividerModule,
    PhxDropdownModule,
    PhxMenuButtonModule,
    PhxMenuModule,
    PhxTooltipModule,
    InfoPopupModule,
    TooltipDirectiveModule,
    PhxIconModule,
    PhxUnderlineModule,
    DismissalNoteModule,
  ],
  declarations: COMPONENTS,
  exports: [NgCommonModule, COMPONENTS, UpsellModule, PhxTooltipModule, InfoPopupModule, TooltipDirectiveModule],
})
export class CommonComponentsModule { }
